import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const QuickMenuList = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	return (
		<div className={`quick-button-group`}>
			{/*{reduxChannel?.ingredient_menu_show && (*/}
			<button
				className={`quick-button`}
				onClick={() => history.push(`/together/channel/ingredients`)}
			>
				<img
					src={`/assets/images/channel/quick1.png`}
					alt={`성분별 quick`}
					style={{
						width: "auto",
						height: "1.8em",
					}}
				/>
				성분별 제안
			</button>
			{/*)}*/}
			{/*{reduxChannel?.function_menu_show && (*/}
			<button
				className={`quick-button`}
				onClick={() => history.push(`/together/channel/functions`)}
			>
				<img
					src={`/assets/images/channel/quick2.png`}
					alt={`고민별 quick`}
					style={{
						width: "auto",
						height: "1.8em",
					}}
				/>
				고민별 제안
			</button>
			{/*)}*/}
			{/*{reduxChannel?.combination_menu_show && (*/}
			<button
				className={`quick-button`}
				onClick={() => history.push(`/together/channel/combinations`)}
			>
				<img
					src={`/assets/images/channel/quick3.png`}
					alt={`조합 제안 quick`}
					style={{
						width: "auto",
						height: "1.8em",
					}}
				/>
				조합별 제안
			</button>
			{/*)}*/}
			{/*{reduxChannel?.inquiry_link && (*/}
			<button
				className={`quick-button`}
				onClick={() => {
					if (reduxChannel?.inquiry_link) {
						return window.open(reduxChannel?.inquiry_link);
					} else {
						// toastAlert('곧 찾아뵙겠습니다.');
						alert("곧 찾아뵙겠습니다.");
					}
				}}
			>
				<img
					src={`/assets/images/channel/quick4.png`}
					alt={`1:1 상담 quick`}
					style={{
						width: "auto",
						height: "1.8em",
					}}
				/>
				1:1 상담
			</button>
			{/*)}*/}
		</div>
	);
};
export default QuickMenuList;
